module.exports = __webpack_public_path__ + "0af5d249/img/note-edit-icon.acae1669.svg";